import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/app/hooks";
import { logout } from "../../../redux/slices/authSlice";
import { Cancel } from "@mui/icons-material";
import "./PaymentStatus.scss";

const PaymentFailure: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBackToLogin = () => {
    dispatch(logout());
    navigate("/virtual-school/virtual-login", { state: { prefillUsername: true } });
  };

  return (
    <div className="paymentStatusCtn">
      <div className="paymentCard">
        <div className="failureIconOuter">
          <div className="failureIconInner">
            <Cancel />
          </div>
        </div>
        <h2 className="statusTitle">Payment Failed</h2>
        <p className="statusDescription">
          Unfortunately, your payment could not be processed at this time. Please try logging in again to retry the payment.
        </p>
        <div className="actionBtnRow">
          <button onClick={handleBackToLogin} className="btnConfirm">Try Again</button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
